// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "segment-1oAMS";
var _4 = "segment__info-34Mnh";
var _5 = "segment__location-10Rnu";
var _6 = "segment__flight-13Mih";
var _7 = "segment__transfer-27Iuz";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "segment", _4 as "segment__info", _5 as "segment__location", _6 as "segment__flight", _7 as "segment__transfer" }
export default { "__esModule": _1, "tabletMiddle": _2, "segment": _3, "segment__info": _4, "segment__location": _5, "segment__flight": _6, "segment__transfer": _7 }
